// extracted by mini-css-extract-plugin
module.exports =  {"title":"title_BKZzwXpq","sheetsIcon":"sheetsIcon_3BDYK9z8","masterFileBtn":"masterFileBtn_V8QwWvBk","syncAllContainer":"syncAllContainer_SS0Ld9vr","syncAll":"syncAll_KL81mMwD"};